export default "__VITE_ASSET__BE_6O8EK__"